import { Injectable, signal, WritableSignal } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class tasksServices extends ApiBaseService {
    constructor(public http: HttpClient) {
        super(http, '/tasks');
    }

    private activityPipeline = new Subject<any>();
    activityPipeline$ = this.activityPipeline.asObservable();

    setActivityPipeline(result: any) {
        this.activityPipeline.next(result);
    }

    private resultSubject = new Subject<any>();
    result$ = this.resultSubject.asObservable();

    // Initialize BehaviorSubject with filters loaded from localStorage
    private filterSubject = new BehaviorSubject<any[]>(this.loadFiltersFromStorage());
    filter$ = this.filterSubject.asObservable();

    setFilter(filters: any[]) {
        this.filterSubject.next(filters);
    }

    setResult(result: any) {
        this.resultSubject.next(result);
    }

    getCurrentFilters(): any[] {
        return this.filterSubject.value;
    }

    private loadFiltersFromStorage(): any[] {
        try {
            const user = JSON.parse(localStorage.getItem("userData") || "{}");
            if (!user?.id) return [];
    
            // Load activity filter using per-user key
            const storedFilter = localStorage.getItem(`user_${user.id}_activity-filter`);
            
            if (storedFilter) {
                const parsedFilter = JSON.parse(storedFilter);
                return parsedFilter.data || [];
            }
    
            return [];
        } catch (error) {
            console.error('Error loading filters from storage:', error);
            return [];
        }
    }
    

    // Optional: Method to refresh filters from storage
    refreshFiltersFromStorage(): void {
        const filters = this.loadFiltersFromStorage();
        this.filterSubject.next(filters);
    }

    getTaskTypes(): Observable<any> {
        return this.http.get(`${environment.apiUrl}/tasks/getAllTaskTypes`);
    }

    getActivityTypes(): Observable<any> {
        return this.http.get(`${environment.apiUrl}/tasks/getAllActivityTypes`);
    }

    getAllActivities(params?): Observable<any> {
        return this.http.get(`${environment.apiUrl}/tasks/getAllActivities`, {params});
    }

    getAppoitmentStatus(): Observable<any> {
        return this.http.get(`${environment.apiUrl}/tasks/getAppoitmentStatus`);
    }

    addActivity(body : any): Observable<any> {
        return this.http.post(`${environment.apiUrl}/tasks/addActivity`, body);
    }

    rescheduleAppointment(payload: any): Observable<any> {
        return this.http.post(`${environment.apiUrl}/tasks/reschedule`, payload);
    }

    getActivityNavigation(activityId: number, lastRequest: any) {
        const params = {
          lastRequest: JSON.stringify(lastRequest)
        };
        return this.http.get<{previousId: number | null, nextId: number | null}>(
          `${environment.apiUrl}/tasks/navigation/${activityId}`,
          { params }
        );
      }

      getActivityById(id: number, company_id: number) {
        const params = { id: id.toString(), company_id: company_id.toString() };
        return this.http.get<any>(`${environment.apiUrl}/tasks/openModal`, { params });
      }

      checkActiveFollowUp(leadId: number, excludeTaskId?: number): Observable<{ hasActiveFollowUp: boolean; count: number }> {
        const params: any = {};
        if (excludeTaskId) {
          params.excludeTaskId = excludeTaskId.toString();
        }
        return this.http.get<{ hasActiveFollowUp: boolean; count: number }>(
          `${environment.apiUrl}/tasks/check-active-followup/${leadId}`,
          { params }
        );
      }

    deleteWithScope(id: number, companyId: number, recurrenceScope: string): Observable<any> {
        return this.http.delete(`${environment.apiUrl}/tasks/${id}`, {
            params: { company_id: companyId.toString(), recurrenceScope }
        });
    }
}